import React, {forwardRef, useEffect, useRef, useState} from "react";
import {
    Container, FormControl,
    Grid, InputLabel,
    MenuItem,
    Select
} from "@mui/material";
import {useTranslation} from "react-i18next";
import {Navigate, useOutletContext} from "react-router-dom";
import '../App.css';
import useFetch from "../hooks/useFetch";
import VehicleSelector from "./v2/VehicleSelector";


// TODO Utiliser VehicleSelector ?
function ServiceStep1({
                          previousBtn,
                          nextBtn,
                          contentLoadedHandler,
                          setLabel,
                          validateVehicle,
                          vehicle
                      }, ref) {
    const [apiUri] = useOutletContext();
    const {t} = useTranslation('common');

    const [loaded, setLoaded] = useState(false);
    const [vehicleList, setVehicleList] = useState([]);
    const [localVehicle, setLocalVehicle] = useState(vehicle);

    const vehicleRef = useRef();
    vehicleRef.current = localVehicle;

    const {call} = useFetch();

    useEffect(() => {
        setLabel('service.step1.title');
        previousBtn.current.style.display = 'none';
        nextBtn.current.addEventListener('click', nextClickedHandler);
        vehicleIndexGet();
        return () => {
            if (nextBtn.current) {
                nextBtn.current.removeEventListener('click', nextClickedHandler);
            }
        }
    }, [])

    // TODO Meme que VehicleIndex
    async function vehicleIndexGet() {
        call(apiUri + 'vehicle_index', (resultData => {
            setLoaded(true);
            contentLoadedHandler();
            setVehicleList(resultData.vehicles);
            setLocalVehicle(resultData.vehicles[0] || null);
        }));
    }

    function nextClickedHandler() {
        if (vehicleRef.current != null) {
            validateVehicle(vehicleRef.current);
        }
    }

    const vehicleSelectedHandler = (vehicleId) => {
        let vehicle = vehicleList.find((elem => elem.id == vehicleId));
        setLocalVehicle(vehicle);
    }

    return (
        <Container>
            {loaded ?
                // <Grid container justifyContent="left" alignItems="center" minHeight="20vh">
                <div className="flex flex-col w-full mt-5">
                    {vehicleList.length == 0 ?
                        <>
                            <h3>
                                {t("service.step1.no_vehicle")}
                            </h3>
                        </>
                        :
                        <VehicleSelector
                            vehicleList={vehicleList}
                            selectedVehicleId={localVehicle?.id}
                            vehicleSelectedHandler={vehicleSelectedHandler}
                        />
                    }
                </div>
                // </Grid>
                : null
            }

        </Container>
    )
}
;

export default forwardRef(ServiceStep1);